<template>

  <ContentTemplate title="Change Password" :container-size-small="true">
    <form>
      <FormGroupSection
          v-for="(item, index) in passwordFormInfos"
          :key="index"
          :form-element="item"
          v-model:input-value="form[item.input.name]"
          :validator="v$.form[item.input.name]"/>

      <div class="row">
        <div class="col-12 d-flex justify-content-end mt-2">
          <ButtonElement
              @clickOnButton="changePassword()"
              class="btn--ms btn--accent">
            Update Password
          </ButtonElement>
        </div>
      </div>
    </form>
  </ContentTemplate>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {ButtonElement, ContentTemplate, FormGroupSection,} from '@shared/components';
import useVuelidate from '@vuelidate/core';
import {required} from '@vuelidate/validators';
import {AccountNs, CommonNs} from "@shared/types";
import {useAccountStore} from "@domains/account/stores/account.store";
import {toast} from '@shared/ms-components'

export default defineComponent({
  name: 'PasswordView',
  components: {
    ButtonElement,
    FormGroupSection,
    ContentTemplate,
  },
  data() {
    return {
      form: {} as { [key: string]: string },
      passwordFormInfos: [] as CommonNs.InputFormGroup[],
    };
  },
  setup() {
    return {v$: useVuelidate()};
  },
  mounted(): void {
    this.buildForm();
  },
  validations() {
    return {
      form: {
        currentPassword: {required},
        newPassword: {required},
      },
    };
  },
  methods: {
    buildForm(): void {
      this.form = {
        currentPassword: '',
        newPassword: '',
      };
      this.passwordFormInfos = [
        {
          label: 'Current Password',
          iconType: 'fal',
          icon: 'Lock',
          input: {
            name: 'currentPassword',
            type: 'password',
            placeholder: 'Current Password',
          },
        },
        {
          label: 'New Password',
          iconType: 'fal',
          icon: 'Lock',
          description: 'Use a passphrase of at least 8 characters or a password of at least 8 characters containing letters and numbers.',
          input: {
            name: 'newPassword',
            type: 'password',
            placeholder: 'New Password',
            withButton: true,
          },
        },
      ] as CommonNs.InputFormGroup[];
    },

    changePassword(): void {
      this.v$.$touch();
      // @ts-ignore
      if (this.v$.form.$invalid) {
        return;
      }

      const payload = {
        password: this.form.currentPassword,
        newPassword: this.form.newPassword,
      } as AccountNs.ChangePasswordRequest;

      const accountStore = useAccountStore();
      accountStore.changePassword(payload).then(() => {
        toast.success('Password successfully changed');
      })
    },
  },
});
</script>
